import { render } from "./SvgObject.vue?vue&type=template&id=1acb8330&ts=true"
import script from "./SvgObject.vue?vue&type=script&lang=ts"
export * from "./SvgObject.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agnisvegners/Projects/anatomynext/hpc-new/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__